import { Stack, styled } from '@mui/material';

export const CellNewRed = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.red.light,
  borderRadius: 16,
  padding: '7px 10px',
}));
